<div *ngFor=" let mensagem of mensagens; let i = index" class="alert alert-dismissible"
    [ngClass]="{'alert-info':mensagem.nivel_pendencia.descricao ==='info'}">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">×</span>
    </button>
    <p>
        <i *ngIf="mensagem.nivel_pendencia.descricao ==='info'" class="glyphicon glyphicon-info-sign"></i>
        {{mensagem.descricao}}
    </p>
</div>